import React, { useState } from "react";

// Get suggested slug based on current quarter
function getSuggestedSlug() {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth(); // 0-11
  const quarter = Math.floor(month / 3) + 1;
  return `${year}-q${quarter}`;
}

function PublishModal({ entry, entityName, onClose, onPublish }) {
  const [slug, setSlug] = useState(entry.slug || getSuggestedSlug());
  const [isValid, setIsValid] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  // Validate slug format
  const validateSlug = (value) => {
    if (!value) {
      setIsValid(false);
      setErrorMessage("Slug is required");
      return false;
    }
    if (value === "current") {
      setIsValid(false);
      setErrorMessage("'current' is a reserved value");
      return false;
    }
    setIsValid(true);
    setErrorMessage("");
    return true;
  };

  const handleSlugChange = (e) => {
    const value = e.target.value.trim();
    setSlug(value);
    validateSlug(value);
  };

  const handlePublish = () => {
    if (validateSlug(slug)) {
      onPublish(entry.id, slug);
    }
  };

  return (
    <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Publish {entityName} List</h5>
            <button type="button" className="btn-close" onClick={onClose} />
          </div>
          <div className="modal-body">
            <div className="mb-3">
              <p className="text-muted">To publish this list, you need to set a slug for the API endpoint.</p>
            </div>
            <div className="mb-3">
              <label className="form-label" htmlFor="slug-input">
                Slug (required)
              </label>
              <input
                id="slug-input"
                type="text"
                className={`form-control ${!isValid ? "is-invalid" : ""}`}
                value={slug}
                onChange={handleSlugChange}
                placeholder="YYYY-q#"
              />
              {!isValid && <div className="invalid-feedback">{errorMessage}</div>}
              <small className="form-text text-muted">
                <i className="fas fa-info-circle me-1" />
                Suggested format: YYYY-q# (e.g., 2025-q1)
              </small>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button type="button" className="btn btn-success" onClick={handlePublish} disabled={!isValid}>
              <i className="fas fa-eye me-1" />
              Publish
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PublishModal;
